
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/home",
      function () {
        return require("private-next-pages/nl/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/home"])
      });
    }
  